export const sortEnum: { [key: string]: "asc" | "desc" | undefined } = {
  asc: "asc",
  desc: "desc",
};

export const sortByEnum: {
  patients: "patientCount";
  encounters: "encounterCount";
} = {
  patients: "patientCount",
  encounters: "encounterCount",
};

export function sortData(
  sort: "asc" | "desc",
  sortBy: ProjectCodeKeys,
  data: {
    grouped: (GroupedDiagnosisResponse | GroupedProcedureResponse)[];
    ungrouped: ProjectCode[];
  },
) {
  const groupedCodes = data.grouped
    ? data.grouped.map((item) => {
        const codesSorted = item.grouped.sort((a, b) => {
          if (sort === sortEnum.asc) {
            return Number(a[sortBy]) - Number(b[sortBy]);
          }
          return Number(b[sortBy]) - Number(a[sortBy]);
        });
        return Object.assign({ ...item }, { grouped: codesSorted });
      })
    : [];

  const ungroupedCodes = data.ungrouped
    ? data.ungrouped.sort((a, b) => {
        if (sort === sortEnum.asc) {
          return Number(a[sortBy]) - Number(b[sortBy]);
        }
        return Number(b[sortBy]) - Number(a[sortBy]);
      })
    : [];

  return { ...data, grouped: groupedCodes, ungrouped: ungroupedCodes };
}

export function getTableDataIsRelatedValues(
  tableData:
    | {
        grouped: (GroupedDiagnosisResponse | GroupedProcedureResponse)[];
        ungrouped: ProjectCode[];
      }
    | undefined,
) {
  const groupedCodes = tableData?.grouped.map((item) => item.grouped);
  const flatGroupedCodes = groupedCodes?.flatMap((group) => group);
  const allCodes = [
    ...(flatGroupedCodes || []),
    ...(tableData?.ungrouped || []),
  ];
  return allCodes.reduce((acc: { [key: string]: boolean | null }, curr) => {
    return { ...acc, [curr.id]: curr.isRelated };
  }, {});
}

export function isThisCodeRelated(
  codeMarkedValue: boolean,
  APIValue: boolean | null,
) {
  if (codeMarkedValue !== undefined) {
    return codeMarkedValue;
  }
  if (APIValue === null || APIValue === true) {
    return true;
  }
  return false;
}
